export default __webpack_public_path__ + "static/Entenda0048-6f641dd4251757ec1c864c5f55a3985d.jpg";